<template>
  <div class="">
    <div class="tw-bg-black tw-py-4 tw-px-8 tw-text-white">
      <h3 class="tw-text-2xl tw-font-black tw-uppercase">Your Bag</h3>
    </div>
    <div class="tw-py-8 tw-px-8">
      <div v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
        <BagProduct
          class="tw-w-full tw-mb-4 tw-text-xl tw-rounded-lg tw-border tw-shadow-lg tw-border-slate-100 tw-rounded-3xl "
          v-for="product in basketStore.basket.products"
          @emitRemoveProduct="removeProduct"
          @emitUpdateProduct="handleEmit"
          :key="'bp-'+product.id.toString()"
          :size="'small'"
          :product="product"
          :recipient="product.recipient" />
      </div>
      <div class="tw-text-center" v-else>
          Your bag is empty!
        </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { reactive, computed } from 'vue'
import { DateTime } from "luxon";

// Data
import { useBasketStore } from "../../stores/basket";
import { useUserStore } from '../../stores/user';

import BagProduct from './_BagProduct.vue';
import TwButton from '../../components/TwButton.vue'

const basketStore = useBasketStore();
const userStore = useUserStore();

const removeProduct = ((bpid: number) => {
  basketStore.removeProduct(bpid)
})

const handleEmit = (() => {
  // do nothing
})

</script>